import { SelectOption, SelectProps } from '../components/forms/select/select'
import { TextfieldProps } from '../components/forms/textfield/textfield'
import { ProductFiltersSectionProps } from '../modules/checkout/product-filters-section'
import { EventView } from '../types'

export const getProductFilters = (view: EventView): ProductFiltersSectionProps => {
    const { state, update } = view
    const { lang, productCategories, productSearch } = state

    const categories: SelectOption[] = [
        {
            value: '',
            name: lang.allProducts,
        },
    ]

    if (productCategories) {
        productCategories.forEach(function (category) {
            categories.push({
                value: String(category.id),
                name: category.name,
            })
        })
    }

    const dropdown: SelectProps = {
        options: categories,
        value: state.selectedCategory ?? '',
        onChange: (value) => {
            if (value) {
                state.productsPageNumber = 1
                state.selectedCategory = value
            } else {
                delete state.selectedCategory
            }

            update()
        },
    }

    const textField: TextfieldProps = {
        id: 'product-search',
        placeholder: lang.searchProduct,
        value: productSearch ?? '',
        onChange: (value) => {
            state.productSearch = value
            update()
        },
    }

    return {
        categories: dropdown,
        search: textField,
    }
}
